
import React, { useEffect, useRef } from 'react';

import styles from './styles.module.scss';

interface IPageHeader {
  faded?: boolean;
  staticHeader?: boolean;
  className?: string;
  backgroundImage?: string;
  children: any;
}

const PageHeader = ({ faded = false, staticHeader, className = "", backgroundImage = "", children } : IPageHeader) => {
  const pageHeaderParallaxRef = useRef<HTMLDivElement>(null);
  const blackCoverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!staticHeader) {
      const parallaxEffect = () => {
        if (pageHeaderParallaxRef && pageHeaderParallaxRef.current && blackCoverRef && blackCoverRef.current) {
          const currentScroll = window.scrollY;
    
          let translateY = currentScroll / 2;
          if (translateY < 0) translateY = 0;
          const backgroundColorOpacity = currentScroll / 1000;
          const opacity = 1 - backgroundColorOpacity;
  
          pageHeaderParallaxRef.current.style.transform = `translateY(${translateY}px)`;
          pageHeaderParallaxRef.current.style.opacity = `${opacity}`;
          blackCoverRef.current.style.backgroundColor = `rgba(0, 0, 0, ${backgroundColorOpacity})`;
        }
      };
  
      parallaxEffect();
  
      window.addEventListener('scroll', parallaxEffect);
      return () => window.removeEventListener('scroll', parallaxEffect);
    }
  }, [pageHeaderParallaxRef, staticHeader]);

  
  const pageHeaderParallaxStyle = styles.pageHeaderParallax + (faded ? ` ${styles.faded}` : "");

  const pageHeaderStyle = `${styles.pageHeader} ${className} ${(staticHeader ? ` ${styles.staticHeader}` : "")}`; 

  return (
    <div className={pageHeaderStyle} style={{backgroundImage: `url(${backgroundImage})`}}>
      <div className={styles.blackCover} ref={blackCoverRef}>
        <div className={pageHeaderParallaxStyle} ref={pageHeaderParallaxRef}>
  
          <div className={styles.pageHeaderContent}>
            { children }
          </div>

        </div>
      </div>
    </div>
  )
};

export default PageHeader;
